import React from 'react';
import { motion } from 'framer-motion';
interface LeafConfig {
  id: number;
  x: number; // starting left % position
  size: number; // px
  duration: number; // fall duration in seconds
  delay: number; // start delay
  drift: number; // horizontal drift amplitude px
  rotation: number; // total rotation degrees
  opacity: number;
  color: string;
}
const LEAVES: LeafConfig[] = [{
  id: 1,
  x: 8,
  size: 12,
  duration: 18,
  delay: 0,
  drift: 40,
  rotation: 200,
  opacity: 0.28,
  color: '#FF8C42'
}, {
  id: 2,
  x: 22,
  size: 9,
  duration: 22,
  delay: 3,
  drift: -30,
  rotation: -180,
  opacity: 0.2,
  color: '#E8722A'
}, {
  id: 3,
  x: 38,
  size: 14,
  duration: 16,
  delay: 7,
  drift: 50,
  rotation: 260,
  opacity: 0.25,
  color: '#FF9F5A'
}, {
  id: 4,
  x: 55,
  size: 10,
  duration: 20,
  delay: 1.5,
  drift: -40,
  rotation: -220,
  opacity: 0.22,
  color: '#FF8C42'
}, {
  id: 5,
  x: 68,
  size: 13,
  duration: 24,
  delay: 5,
  drift: 35,
  rotation: 190,
  opacity: 0.18,
  color: '#D4621E'
}, {
  id: 6,
  x: 80,
  size: 8,
  duration: 17,
  delay: 9,
  drift: -25,
  rotation: -160,
  opacity: 0.24,
  color: '#FF9F5A'
}, {
  id: 7,
  x: 92,
  size: 11,
  duration: 21,
  delay: 2,
  drift: 45,
  rotation: 240,
  opacity: 0.2,
  color: '#E8722A'
}, {
  id: 8,
  x: 15,
  size: 10,
  duration: 19,
  delay: 12,
  drift: -35,
  rotation: -200,
  opacity: 0.22,
  color: '#FF8C42'
}];
// Simple organic leaf SVG path
function LeafShape({
  size,
  color
}: {
  size: number;
  color: string;
}) {
  return <svg width={size} height={size * 1.3} viewBox="0 0 20 26" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-136">
      <path d="M10 24 C10 24 2 18 2 10 C2 4 6 1 10 1 C14 1 18 4 18 10 C18 18 10 24 10 24Z" fill={color} data-id="element-137" />
      <path d="M10 24 C10 24 10 12 10 1" stroke={color} strokeWidth="0.8" strokeOpacity="0.5" fill="none" data-id="element-138" />
      <path d="M10 14 C7 11 4 10 2 10" stroke={color} strokeWidth="0.6" strokeOpacity="0.4" fill="none" data-id="element-139" />
      <path d="M10 10 C13 7 16 6 18 6" stroke={color} strokeWidth="0.6" strokeOpacity="0.4" fill="none" data-id="element-140" />
    </svg>;
}
interface FallingLeavesProps {
  /** Number of leaves to show. Defaults to all 8. Pass fewer for mobile. */
  count?: number;
}
export function FallingLeaves({
  count = 8
}: FallingLeavesProps) {
  const visibleLeaves = LEAVES.slice(0, count);
  return <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" style={{
    zIndex: 5
  }} data-id="element-141">
      {visibleLeaves.map(leaf => <motion.div key={leaf.id} className="absolute" style={{
      left: `${leaf.x}%`,
      top: 0,
      opacity: leaf.opacity,
      willChange: 'transform'
    }} initial={{
      y: -80,
      x: 0,
      rotate: 0
    }} animate={{
      y: ['−80px', '110vh'],
      x: [0, leaf.drift * 0.4, leaf.drift * -0.2, leaf.drift * 0.6, leaf.drift * -0.1, leaf.drift * 0.3, 0],
      rotate: [0, leaf.rotation * 0.3, leaf.rotation * 0.6, leaf.rotation * 0.8, leaf.rotation]
    }} transition={{
      duration: leaf.duration,
      delay: leaf.delay,
      repeat: Infinity,
      ease: 'linear',
      x: {
        duration: leaf.duration,
        delay: leaf.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      },
      rotate: {
        duration: leaf.duration,
        delay: leaf.delay,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} data-id="element-142">
          <LeafShape size={leaf.size} color={leaf.color} data-id="element-143" />
        </motion.div>)}
    </div>;
}